import React from 'react';
import s from "./Faq.module.css";
import {motion} from 'framer-motion';
import {Collapse} from 'antd';
import minus from '../../../assets/img/minus.svg'
import plus from '../../../assets/img/plus.svg'
import screenshot1 from '../../../assets/img/faq/screenshot1.png'
import screenshot2 from '../../../assets/img/faq/screenshot2.png'
import screenshot3 from '../../../assets/img/faq/screenshot3.png'
import screenshot4 from '../../../assets/img/faq/screenshot4.png'
import screenshot5 from '../../../assets/img/faq/screenshot5.png'
import screenshot52 from '../../../assets/img/faq/screenshot5-2.png'
import screenshot6 from '../../../assets/img/faq/screenshot6.png'
import screenshot7 from '../../../assets/img/faq/screenshot7.png'
import screenshot71 from '../../../assets/img/faq/screenshot71.png'
import screenshot8 from '../../../assets/img/faq/screenshot8.png'
import screenshot81 from '../../../assets/img/faq/screenshot81.png'
import screenshot9 from '../../../assets/img/faq/screenshot9.png'
import screenshot91 from '../../../assets/img/faq/screenshot91.png'
import screenshot101 from '../../../assets/img/faq/screenshot101.png'
import screenshot11 from '../../../assets/img/faq/screenshot11.png'
import screenshot12 from '../../../assets/img/faq/screenshot12.png'
import screenshot13 from '../../../assets/img/faq/screenshot13.png'
import screenshot14 from '../../../assets/img/faq/screenshot14.png'
import screenshot15 from '../../../assets/img/faq/screenshot15.png'
import screenshot16 from '../../../assets/img/faq/screenshot16.png'

const {Panel} = Collapse;

const Faq = () => {

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
            className={s.motion_div}
        >
            <div className={s.wrapper}>
                <div className={s.container}>
                    <div className={s.title}>
                        Frequently Asked Questions (FAQ)
                    </div>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"How to open a bank account for private person?"} key={1}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>
                                <div className={s.flex}>
                                    <div className={s.text}>
                                        1. Visit <a href="https://www.luxpay.lt/"
                                                    className={s.link_small}>www.luxpay.lt</a> and click on “<b>Open
                                        Account</b>”
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot1} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        2. Click on “<b>Create your private account</b>”. Do not choose “Submit business
                                        application”
                                        option. Even if you want to open a business account only, you, as CEO /
                                        signatory
                                        of the company, must complete KYC check first.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot2} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        3. Enter your personal information, email address, password which will be used
                                        for
                                        signing up and press “<b>Create Account</b>”. Accepting our Privacy policy,
                                        Terms of
                                        use and confirmation you are not a PEP is mandatory. If you are PEP, please
                                        contact us by sending email to compliance@luxpay.lt
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot3} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <p className={s.text}>
                                        4. You will receive an email with verification link. There is a possibility to
                                        re-send
                                        verification link or use a different email if needed.
                                    </p>
                                    <div className={s.screenshot}>
                                        <img src={screenshot4} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        5. After your email is verified, you will be requested to verify your phone
                                        number
                                        which will be used for signing up. SMS with 6-digit verification code will be
                                        sent to provided number.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot5} alt=""/>
                                    </div>
                                </div>
                                <div className={s.flex}>
                                    <div className={s.text}>
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot52} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <p className={s.text}>
                                        6. Next step is verification of ID document. You will be requested to choose a
                                        country where ID document has been issued and document type. If you are non-EU
                                        resident, please perform verification with your passport. Verification can be
                                        done using your computer and its webcam or continued on your phone. To complete
                                        this step, you will have to take live picture – your ID must be held against the
                                        camera.
                                    </p>
                                    <div className={s.screenshot}>
                                        <img src={screenshot6} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        7. After a picture of ID document is taken, you will be asked to take a selfie.
                                        This
                                        can be done using your computer and its webcam or continued on your phone.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot7} alt=""/>
                                    </div>
                                </div>

                                <div>
                                    <p>
                                        8. Once the selfie is taken, you will be requested to fill in LuxPay
                                        Questionnaire.
                                        Please note that questions marked with (*) are mandatory.
                                    </p>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        9. Once the Questionnaire is answered and submitted, you will see information
                                        that
                                        your application is being checked. The system might ask you to re-take picture
                                        of your ID due to unsatisfactory results, such as bad lighting.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot8} alt=""/>
                                    </div>
                                </div>
                                <div className={s.flex}>
                                    <div className={s.text}>
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot9} alt=""/>
                                    </div>
                                </div>

                                <div>
                                    <p>
                                        10. Please note that each applicant is reviewed manually. The system might
                                        redirect
                                        to your online banking page. However, until your application is approved, you
                                        won’t be able to make or receive payments or top-up your account.
                                    </p>
                                </div>

                                <div>
                                    <p className={s.bold}>
                                        LuxPay Compliance department will contact you via email and request
                                        additional
                                        information and documents if need needed as well as provide you instructions
                                        how
                                        to make transactions if application is successful. Please contact us via
                                        email &nbsp;
                                        <a className={s.link_small}
                                           href="mailto:onboarding@luxpay.lt">onboarding@luxpay.lt</a> if you have
                                        any issues with onboarding process.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"How to open a bank account for a company?"} key={2} className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        1. In order to apply for business account, CEO / signatory of the Company has to
                                        pass our KYC check and open personal account at first. If you do not have
                                        personal account, please contact <a className={s.link_small}
                                                                            href="mailto:onboarding@luxpay.lt."> onboarding@luxpay.lt</a>.
                                        If you do have
                                        personal
                                        account, go to your online banking, click on your name seen in upper right
                                        corner and choose “Add new company”.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img className={s.fix_height} src={screenshot71} alt=""/>
                                    </div>
                                </div>

                                <div>
                                    <p>
                                        2. Fill in all fields about the Company (for Beneficial owner type, please
                                        choose
                                        “Ultimate beneficial owner”), agree with our Privacy Policy and Terms of Use and
                                        click on “<b>Create Company</b>”.
                                    </p>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        3. Under the “Upload company documents” click on “<b>Start</b>”.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot81} alt=""/>
                                    </div>
                                </div>

                                <div>
                                    <p>
                                        4. Carefully read and agree with processing of Your personal data. Then press
                                        “<b>Next</b>”.
                                    </p>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        5. Fill in information about the Company and click “<b>Next</b>”. Please note
                                        some information
                                        will be already pre-filled from section 2.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot91} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        6. Provide information about the UBOs (persons owning at least 25% of the
                                        company)
                                        and Directors. Choose their positions within the company (one person can be both
                                        UBO and Director). You can add persons by clicking “<b>Add participant</b>” if
                                        the
                                        company has more than one Director and / or UBO. Delete persons by clicking
                                        “<b>Remove</b>”. ID documents of UBOs and Directors must be verified. You have
                                        two
                                        options: click “<b>Start verification now</b>” and the window with the check
                                        will open
                                        in a new tab. Alternatively, you may send the verification link via email or
                                        copy it. We strongly advise you to have prepared high-quality, unedited (saved
                                        directly from camera, not resized or saved as PDF) pictures of UBOs / Directors
                                        ID documents (both sides of ID card or passport) and perform this step yourself.
                                        Then click “<b>Next</b>”.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot101} alt=""/>
                                    </div>
                                </div>

                                <div>
                                    <p>
                                        7. Fill in LuxPay Questionnaire and upload as many requested documents as you
                                        possibly can. Please have prepared folllowing corporate documents in
                                        advance: <br/>
                                        <ul>
                                            <li className={s.li}>
                                                Articles of association/Company’s bylaws Signed by Director/authorized
                                                signatory;
                                            </li>
                                            <li className={s.li}>
                                                Extract from local Business Register With visible Company’s name,
                                                address,
                                                status, date of incorporation, director/legal representative;
                                            </li>
                                            <li className={s.li}>
                                                Ownership Structure. Must be dated and signed by Director/authorized
                                                signatory.
                                                Must include natural and legal persons and % of their equity showing the
                                                entire
                                                ownership chain from the Applicant’s entity to its beneficial owners –
                                                natural
                                                persons. During the process, we might require additional documents.
                                                Questions
                                                marked with (*) are mandatory.
                                            </li>
                                        </ul>

                                    </p>
                                </div>

                                <div>
                                    <p>
                                        8. Once the Questionnaire is answered and submitted, below window appears. If
                                        you
                                        notice any errors, details can be edited. If everything is correct, press
                                        “<b>SUBMIT</b>”.
                                    </p>
                                </div>

                                <div>
                                    <p>
                                        9. Your application is being reviewed now. You can review your current
                                        verification
                                        status by clicking on your company name seen in upper right corner of your
                                        internet banking. Then on “<b>Settings</b>” and “<b>Verification</b>”.
                                    </p>
                                </div>

                                <div>
                                    <p className={s.bold}>
                                        Compliance department will contact you via email and request additional
                                        information and documents if needed as well as provide you instructions how to
                                        make transactions if application is successful. Please contact us via
                                        email &nbsp;
                                        <a className={s.link_small}
                                           href="mailto:onboarding@luxpay.lt">onboarding@luxpay.lt</a> if
                                        you have any issues with onboarding process.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"What documents do I need to open a bank account?"} key={3}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p className={s.documentSteps}>
                                        1.You need your Passport or your EU ID card and in case of not being resident of the country, a certificate of residency as well.
                                    </p>
                                    <p className={s.documentSteps}>
                                        <p className={s.desktopMarginTitle}>2. If you would like to open a business account, following documents will be needed:</p>
                                        <ul className={s.listOfDocToBank}>
                                        <li className={s.dote}>Articles of association/Company’s bylaws Signed by Director/authorized signatory.</li>
                                        <li className={s.dote}>Extract from local Business Register with company’s name, address, status, date of incorporation, director/legal representative visible on the document.</li>
                                        <li className={s.dote}>Ownership Structure. Must be dated and signed by Director/authorized signatory. Must include natural and legal persons and % of their equity showing the entire ownership chain from the Applicant’s entity to its beneficial owners – natural persons.</li>
                                    </ul>
                                    </p>
                                    <p className={s.documentSteps}>
                                        3. The companies established outside of European Union or operating outside of European Union must provide the information requested by LuxPay through its questionnaires, which is mostly the same as the required documents for EU-based companies:
                                    </p>
                                    <ul className={s.listOfDocToBank}>
                                        <li className={s.dote}><strong>Extract from Business Register</strong> – Full company extract from the official corporate registry, showing key details (name, registration number, status, registered address, shareholders, directors, and UBOs). The customer must also <strong>provide a link to a public database</strong>  where LuxPay can obtain and verify the company’s registry extract.</li>
                                        <li className={s.dote}><strong>If the customer cannot provide such an extract</strong> (e.g., the official business register does not contain all necessary data and information), they must provide any available evidence regarding shareholders, directors, and UBOs:</li>
                                        <li className={s.dash}><strong>Certificate of Incorporation </strong>                                        </li>
                                        <li className={s.dash}><strong>Shareholder Register</strong> – A document listing all shareholders and their ownership percentage.</li>
                                        <li className={s.dash}><strong>Directors Register</strong> – A document listing all directors, including their roles and appointment dates.</li>
                                        <li className={s.dash}><strong>Good Standing Certificate</strong> (if applicable) – Proof that the company is still active and compliant with local regulations.</li>
                                        <li className={s.dash}><strong>Business License(s)</strong> – If the company operates in a regulated industry (e.g., financial services, crypto, etc.), it must provide a valid business license.</li>
                                    </ul>
                                    <p className={s.important}><strong>IMPORTANT :</strong> All documents must be <b>recent</b> (not older than 3 months), <b>translated</b>  into English, and <b>legalized/apostilled</b>. Legalization is not required if LuxPay can verify all data in reliable open sources. </p>

                                    <ul className={s.listOfDocToBank}>
                                        <li className={s.dote}><strong>UBO and Management</strong> (Directors, Board, if any) documents:</li>
                                        <li className={s.dash}><strong>Passport copies of all UBOs (owning 25%+ shares), directors, and authorized signatories</strong> – Must be clear, valid, and certified.</li>
                                        <li className={s.dash}><strong>Proof of Address of UBOs, directors, and authorized signatories</strong> – Recent utility bill, bank statement, or tax document (issued within the last 3 months).</li>
                                        <li className={s.dash}><strong>Power of Attorney</strong>(if applicable) – If someone is acting on behalf of the company, a notarized/apostilled POA is needed.</li>
                                        <li className={s.dash}><strong>Selfie Photo of UBOs and directors</strong></li>
                                        <li className={s.dote}>Completed <strong>KYC Questionnaire</strong>.</li>
                                        <li className={s.dote}><strong>Based on the customer’s risk level</strong>, LuxPay reserves the <b>right</b> and, in some cases, has the <strong>duty to request additional information and documents</strong>,such as:  </li>
                                        <li className={s.dash}><strong>Proof of Wealth / Source of Funds of UBOs</strong> – Documents proving how the Company and UBOs acquired their wealth (e.g., tax returns, salary slips, dividends, property sale agreements).</li>
                                        <li className={s.dash}><strong>Articles of Association (AoA) / Memorandum of Association (MoA)</strong></li>
                                        <li className={s.dash}><strong>Contracts or Invoices with Suppliers & Clients</strong> and other documentation.</li>
                                    </ul>
                                    <p className={s.additionalComponent}>Additional documents might be requested depending on applicants profile and background.</p>
                                </div>

                               

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"How do I know if I have been onboarded?"} key={4}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        You will be contacted via e-mail by LuxPay team.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"What to do if I forgot or blocked my LuxPay login credentials?"} key={5}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        1. Open the link: <a className={s.link_small}
                                                             href="/login">https://bank.luxpay.lt/login</a>
                                    </p>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        2. Press on <a href="/login" className={s.link_small}>Forgot password?</a>.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot11} alt=""/>
                                    </div>
                                </div>

                                <div className={s.flex}>
                                    <div className={s.text}>
                                        3. Enter your e-mail and press <a href="/login" className={s.link_small}>"Continue"
                                        button</a>.
                                    </div>
                                    <div className={s.screenshot}>
                                        <img src={screenshot12} alt=""/>
                                    </div>
                                </div>

                                <div>
                                    <p>
                                        4. Check your mailbox, you will receive e-mail with following instructions.
                                    </p>
                                </div>

                                <div>
                                    <p>
                                        5. Welcome to your new internet banking.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"Which currencies can I open a bank account at LuxPay?"} key={6}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        At the moment, we provide EUR and GBP  currencies. AED currency will be
                                        available in the near future. <br/>
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"What are prohibited industries and jurisdictions?"} key={7}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        <b>The list of prohibited jurisdictions:</b>
                                    </p>
                                </div>

                                <div>
                                    <ul className={s.ul}>
                                        <li className={s.li}>Afghanistan</li>
                                        <li className={s.li}>Belarus</li>
                                        <li className={s.li}>Burkina Faso</li>
                                        <li className={s.li}>Cambodia</li>
                                        <li className={s.li}>Democratic Republic of the Congo</li>
                                        <li className={s.li}>Crimea (Region of Ukraine)</li>
                                        <li className={s.li}>Cuba</li>
                                        <li className={s.li}>Haiti</li>
                                        <li className={s.li}>Yemen</li>
                                        <li className={s.li}>Iran</li>
                                        <li className={s.li}>Iraq</li>
                                        <li className={s.li}>Democratic People's Republic of Korea</li>
                                        <li className={s.li}>Libya</li>
                                        <li className={s.li}>Mali</li>
                                        <li className={s.li}>Myanmar</li>
                                        <li className={s.li}>Nicaragua</li>
                                        <li className={s.li}>Pakistan</li>
                                        <li className={s.li}>Russia</li>
                                        <li className={s.li}>Syria</li>
                                        <li className={s.li}>South Sudan</li>
                                        <li className={s.li}>Trinidad and Tobago</li>
                                        <li className={s.li}>Zimbabwe</li>
                                    </ul>
                                </div>

                                <div>
                                    <p>
                                        <b>The list of prohibited business fields:</b>
                                    </p>
                                </div>

                                <div>
                                    <ul>
                                        <li className={s.li}>Adult entertainment</li>
                                        <li className={s.li}>Shell banks and companies</li>
                                        <li className={s.li}>Counterfeit items</li>
                                        <li className={s.li}>Signal Jammers/Blockers that interferes with cellular/communication
                                            devices
                                        </li>
                                        <li className={s.li}>Credit repair services</li>
                                        <li className={s.li}>Stolen goods including digital and virtual goods</li>
                                        <li className={s.li}>Drugs or drug proprietors selling illegal substances</li>
                                        <li className={s.li}>Surrogacy services</li>
                                        <li className={s.li}>Drug paraphernalia that involves equipment designed for making or using
                                            drugs
                                        </li>
                                        <li className={s.li}>Tattoo Parlours</li>
                                        <li className={s.li}>Espionage equipment and accessories</li>
                                        <li className={s.li}>Tobacco / Cigar / Electronic Cigarette / Nicotine content products</li>
                                        <li className={s.li}>Human remains and body parts</li>
                                        <li className={s.li}>Trade of weapons, ammunition, military arms, explosive devices and firearm
                                            parts
                                        </li>
                                        <li className={s.li}>Illegal investment schemes</li>
                                        <li className={s.li}>Gambling without a license</li>
                                        <li className={s.li}>Illegal downloads of movies, music, computer and video games</li>
                                        <li className={s.li}>Any other category, products or services that LuxPay decides to prohibit, in
                                            its sole discretion.
                                        </li>
                                        <li className={s.li}>Illegal software – e.g. Malware, Software to break encryption of
                                            phones/computers
                                        </li>
                                        <li className={s.li}>Charities or Not-For-Profit Organizations / NGO’s</li>
                                        <li className={s.li}>Illegal sale of financial information (e.g. bank accounts, bank cards)</li>
                                        <li className={s.li}>Non-account customers</li>
                                        <li className={s.li}>Mail order brides services</li>
                                        <li className={s.li}>Arms, defense, military</li>
                                        <li className={s.li}>Poisonous and hazardous materials</li>
                                        <li className={s.li}>Atomic power</li>
                                        <li className={s.li}>Products/Services promoting abuse, hatred, racism, religious persecution,
                                            terrorism, violence or contain offensive content
                                        </li>
                                        <li className={s.li}>Extractive industries</li>
                                        <li className={s.li}>Pyramid or ponzi schemes</li>
                                        <li className={s.li}>Embassies/Consulates</li>
                                        <li className={s.li}>Sanction list inclusions (global)</li>
                                    </ul>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"What services LuxPay provides?"} key={8}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <ul>
                                        <li className={s.li}>Dedicated (individual) IBANs</li>
                                        <li className={s.li}>Access to the e-wallet</li>
                                        <li className={s.li}>Local and cross-border payments in EUR and GBP</li>
                                        <li className={s.li}>1st and 3rd party payments</li>
                                        <li className={s.li}>Payment cards</li>
                                        <li className={s.li}>Easy and understandable platform</li>
                                    </ul>
                                </div>

                                <div>
                                    <p>
                                        <b>Supported currencies:</b>
                                    </p>
                                </div>

                                <div>
                                    <ul>
                                        <li className={s.li}>EUR</li>
                                        <li className={s.li}>GBP</li>
                                    </ul>
                                </div>

                                <div>
                                    <p>
                                        <b>Supported payment rails:</b>
                                    </p>
                                </div>

                                <div>
                                    <ul>
                                        <li className={s.li}>SEPA</li>
                                        <li className={s.li}>Target2</li>
                                        <li className={s.li}>SWIFT</li>
                                        <li className={s.li}>Faster Payment</li>
                                        <li className={s.li}>Fedwire</li>
                                        <li className={s.li}>ACH</li>
                                    </ul>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"Why is my payment in a pending state?"} key={11}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        We do our best to process and send your transfer to the recipient as fast as
                                        possible, however, in some cases the payment can be in a pending state a bit
                                        longer. If you see that your payment is in pending state, this simply means that
                                        it is being processed by one of our payment processors. This process can take up
                                        to 2 business days. After you see that payment is in completed state, it means
                                        that it is on the way to the recipient.
                                    </p>
                                </div>

                                <div>
                                    <p>
                                        To avoid any issues and delays, please make sure that the recipient account
                                        details are correct.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"Why has my payment been declined?"} key={12}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        First of all, please make sure that you have sufficient balance on your account
                                        to make a payment. Alternatively, payment also may be declined if you are
                                        attempting to send funds to an unsupported merchant. If you are still having
                                        issues submitting a payment, please contact our support team and we will do our
                                        best to help.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"What recipient account details do I need to know to make a payment?"} key={13}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        <b>
                                            In order to submit a payment, you have to obtain following recipient
                                            details:
                                        </b>
                                    </p>
                                </div>

                                <div>
                                    <ul>
                                        <li className={s.li}>Recipient full name (Same as declared in the recipient's bank)</li>
                                        <li className={s.li}>BIC/SWIFT code – a bank code that has 8 or 11 characters</li>
                                        <li className={s.li}>Recipient’s IBAN – an account number under the recipient’s bank</li>
                                    </ul>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"Why recipient has not received a payment I sent?"} key={14}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        <b>
                                            The timeframe for payment to arrive is started to calculate after you can
                                            see
                                            it‘s status as ‘Completed’. Estimated timeframes for the payment to arrive
                                            are:
                                        </b>
                                    </p>
                                </div>

                                <div>
                                    <p>
                                        SWIFT payments – up to 5 working days (usually 3 working days) <br/>
                                        SEPA payments – up to 2 working days (usually 1 wokring day)
                                    </p>
                                </div>

                                <div>
                                    <p>
                                        <b>
                                            Please note! This is an estimation, not a guarantee. In some cases, it might
                                            take slightly longer for the payment to reach its destination:
                                        </b>
                                    </p>
                                </div>

                                <div>
                                    <ul>
                                        <li className={s.li}>Some banks and financial institutions do not process payments during
                                            weekends and bank holidays.
                                        </li>
                                        <li className={s.li}>Some banks and financial institutions may take a longer time to process
                                            payments.
                                        </li>
                                        <li className={s.li}>Some banks and financial institutions are required to make additional checks
                                            on your payments to comply with regulations.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"How quickly recipient will receive my payment?"} key={15}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p>
                                        EUR payments within SEPA usually arrive on the same day, but might take up to 2
                                        working days. <br/>
                                        International payments (SWIFT) usually reach recipient within 5 working
                                        days. <br/>
                                        Payment timeframes are estimated and can vary from time to time due to the
                                        changes we make to improve our processing systems.
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse
                        className={s.my_collapse}
                        expandIconPosition={"end"}
                        bordered={false}
                        expandIcon={({isActive}) => isActive ?
                            <img className={s.icon_minus} src={minus} alt=""/> :
                            <img src={plus} className={s.icon_plus} alt=""/>}
                        style={{
                            background: "transparent",
                            alignItems: 'center',
                        }}
                    >
                        <Panel header={"Will additional fees be applied to my SWIFT payment?"} key={16}
                               className={s.panelStyle}>
                            <div className={s.collapse_text}>

                                <div>
                                    <p style={{textAlign: "justify"}}>
                                        International payments, in other words called SWIFT (Society for Worldwide
                                        Interbank Financial Telecommunication) payments, are those, which sent to or
                                        received from accounts in other countries or payments that are not in your base
                                        currency but are from an account in your country. <br/>
                                        International money transfers are basically inter-bank transfers, however, if
                                        two banks are located in different countries, it makes things slightly more
                                        complex. The principle of correspondent banking applies, which means that two
                                        banks need to have an established relationship in order to facilitate a SWIFT
                                        transfer. SWIFT does not actually send money, it simply sends messages between
                                        the banks. Because of this, other systems that require more human intervention
                                        must be used to transfer the actual funds and this, in turn, makes SWIFT
                                        transfers slow. What’s more, the complex nature of these transfers usually
                                        incurs a fee which nearly always gets passed on to consumers. <br/>
                                        If senders’ and recipient banks do not have direct relationships, one or more
                                        intermediary banks must be found to facilitate the transfer. Unfortunately, each
                                        participant of the payment chain might charge its own fees for processing a
                                        relevant payment. <br/>
                                        LuxPay does charge processing fees for transferring money internationally as per
                                        pricelist. However, a beneficiary or an intermediary bank might additionally
                                        charge their own fees for processing an international transfer. <br/>
                                        A bank that is sending funds to your account could also charge a fee. When your
                                        money is in transit, it might be processed by an intermediary bank who might
                                        also deduct a handling fee. Therefore, the amount received might be less than
                                        the amount sent <br/>
                                        Additionally, you may be charged an FX mark-up if payment is instructed in
                                        different currency that a recipient account is able to receive.
                                    </p>
                                </div>


                                <div>
                                    <p>
                                        <b>
                                            We can provide an estimate of the potential fees charged by the
                                            beneficiary/intermediary
                                            banks for processing a SWIFT payment for the following currencies:
                                        </b>
                                    </p>
                                </div>

                                <div>
                                    <ul>
                                        <li className={s.li}>From 15 EUR</li>
                                        <li className={s.li}>From 20 USD</li>
                                        <li className={s.li}>From 15 GBP</li>
                                        <li className={s.li}>From 50 AED</li>
                                    </ul>
                                </div>

                                <div>
                                    <p>
                                        <b>
                                            Please note! Potential fees mentioned above do not include fees charged by
                                            Luxpay.
                                        </b>
                                    </p>
                                </div>

                            </div>
                        </Panel>
                    </Collapse>

                </div>
            </div>
        </motion.div>

    );
};

export default Faq;
